export default __webpack_public_path__ + "static/media/icons8-brezel-100.0c4da5cd.svg";